export interface UserShortProfileDto {
	id: string;
	fullName: string;
	jobTitle: string;
	department: string;
	profilePhoto: string;
}

export enum RefreshStatus {
	RefreshPerformed = 0,
	CallInProgress = 1,
	DndStatusIsNotAllowed = 2,
	RefreshCouldNotBePerformed = 3
}
